module.exports = __webpack_public_path__ + "static/media/planilha-meus-locais.951bcf41.xlsx";